import { render, staticRenderFns } from "./IntegrationCorrectMaisEnvios.vue?vue&type=template&id=1b737274"
import script from "./IntegrationCorrectMaisEnvios.vue?vue&type=script&lang=js"
export * from "./IntegrationCorrectMaisEnvios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports